export const cssBundleHref = "/build/css-bundle-7GE3NSI6.css";